var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYayinSeti = function SvgYayinSeti(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 65C28 44.0132 45.0132 27 66 27C86.9868 27 104 44.0132 104 65V234C104 254.987 86.9868 272 66 272C45.0132 272 28 254.987 28 234V65Z",
    fill: "url(#paint0_linear_4330_4143)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112 128C112 107.013 129.013 90 150 90C170.987 90 188 107.013 188 128V234C188 254.987 170.987 272 150 272C129.013 272 112 254.987 112 234V128Z",
    fill: "url(#paint1_linear_4330_4143)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M196 65C196 44.0132 213.013 27 234 27C254.987 27 272 44.0132 272 65V234C272 254.987 254.987 272 234 272C213.013 272 196 254.987 196 234V65Z",
    fill: "url(#paint2_linear_4330_4143)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66 103C86.9868 103 104 85.9868 104 65C104 44.0132 86.9868 27 66 27C45.0132 27 28 44.0132 28 65C28 85.9868 45.0132 103 66 103Z",
    fill: "#2B81FC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M150 272C170.987 272 188 254.987 188 234C188 213.013 170.987 196 150 196C129.013 196 112 213.013 112 234C112 254.987 129.013 272 150 272Z",
    fill: "#2B81FC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M234 103C254.987 103 272 85.9868 272 65C272 44.0132 254.987 27 234 27C213.013 27 196 44.0132 196 65C196 85.9868 213.013 103 234 103Z",
    fill: "#2B81FC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4330_4143",
    x1: 103.987,
    y1: 27.0112,
    x2: -34.643,
    y2: 70.0148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0226A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2B81FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#86B8FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4330_4143",
    x1: 187.987,
    y1: 90.0083,
    x2: 58.5822,
    y2: 144.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0226A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2B81FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#86B8FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4330_4143",
    x1: 271.987,
    y1: 27.0112,
    x2: 133.357,
    y2: 70.0148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0226A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2B81FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#86B8FD"
  })))));
};
export default SvgYayinSeti;